import React from "react";
import { Box, FormControl, MenuItem, Select } from "@mui/material";

interface columns {
  selected: unknown;
  value: string;
  label: string;
}

interface allColumns {
  value: string;
  label: string;
}

interface ColumnSelectorProps {
  columns: columns[];
  allColumns: allColumns[];
  onChange: (v1, v2) => void;
}

const checkRelatedColumns = (selectedCols, selectableCols: allColumns[]) => {
  let columnParams = selectableCols;
  if (selectedCols.includes("dob")) {
    columnParams = columnParams.filter((c) => c.value !== "dateOfBirth" && c.value !== "ageSex");
  }

  if (selectedCols.includes("dateOfBirth")) {
    columnParams = columnParams.filter((c) => c.value !== "dob" && c.value !== "ageSex");
  }

  if (selectedCols.includes("gender")) {
    columnParams = columnParams.filter((c) => c.value !== "ageSex");
  }

  if (selectedCols.includes("ageSex")) {
    columnParams = columnParams.filter(
      (c) => c.value !== "dob" && c.value !== "dateOfBirth" && c.value !== "gender"
    );
  }
  return columnParams;
};

function ColumnSelector({ columns, allColumns, onChange }: ColumnSelectorProps): JSX.Element {
  const selectedColumns = columns.map((c) => c.selected).filter(Boolean);
  let selectableItems = allColumns.filter((c) => c.value);

  selectableItems = checkRelatedColumns(selectedColumns, selectableItems);

  return (
    <Box
      sx={{
        display: "flex",
        width: "min-content"
      }}
    >
      {columns.map((column, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <FormControl
          sx={{
            paddingRight: 2,
            width: 200,
            boxSizing: "border-box"
          }}
          // eslint-disable-next-line react/no-array-index-key
          key={`form-c-${index}`}
        >
          <Select
            data-testmation="columnSelector"
            value={column.selected}
            onChange={(e) => {
              onChange(index, e.target.value);
            }}
            displayEmpty
            sx={(theme) => ({
              marginTop: theme.spacing(2)
            })}
            inputProps={{ "aria-label": "Without label" }}
          >
            {/* eslint-disable-next-line react/no-array-index-key */}
            <MenuItem key={index} value="">
              None
            </MenuItem>
            {selectableItems.map((c, i) => {
              const showItem = !selectedColumns.includes(c.value);
              return (
                <MenuItem
                  data-testmation={c.value}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`menu-item${i}`}
                  sx={{ display: showItem ? undefined : "none" }}
                  value={c.value}
                >
                  {c.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      ))}
    </Box>
  );
}

export default ColumnSelector;
